import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { Form, Input, Row, Col, message, Modal, Upload } from 'antd';
import { preFixImgUrl } from '@/utils';
import { useRootStore } from '@/contexts';
import { apiBuyerModify, BuyerModifyRequest } from '@/service/api';
import EditPasswordForm from './components/EditPasswordForm';
import apiFileUpload from '@/service/api/fileUpload';


const Profile = () => {
  const { t } = useTranslation();
  const { userStore } = useRootStore()
  const [isEdit, setIsEdit] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm<{
    realName: string,
    nickname: string,
    email: string,
    mobile: string,
  }>()
  const [imageUrl, setImageUrl] = useState<string>();

  const [isEditPassword, setIsEditPassword] = useState(false)
  // 当用户数据变化时，更新表单数据
  useEffect(() => {
    if (userStore.user) {
      form.setFieldsValue({
        realName: userStore.user?.realName,
        nickname: userStore.user?.nickname,
        email: userStore.user?.email,
        mobile: userStore.user?.mobile,
      })
    }
  }, [userStore.user, form])

  const handleEdit = () => {
    if (isEdit) {
      // 取消编辑，恢复原始值
      form.resetFields()
      setImageUrl('');
    }
    setIsEdit(!isEdit)
  }

  const handleSave = async () => {
    try {
      // 表单验证
      const values = await form.validateFields()
      setLoading(true)

      // 构建请求参数
      const modifyData: BuyerModifyRequest = {
        buyerId: userStore.user?.buyerId,
        realName: values.realName,
        nickname: values.nickname,
        email: values.email,
        mobile: values.mobile,
        headimgurl: imageUrl,
      }

      // 调用修改接口
      const res = await apiBuyerModify(modifyData)

      if (res.code === 0) {
        message.success(t('d5bdff27'))
        // 重新获取用户信息以更新store
        await userStore.getUser()
        setIsEdit(false)
      } else {
        message.error(res.msg || t('27604e7c'))
      }
    } catch (error: any) {
      // 表单验证失败或其他错误
      if (error?.errorFields) {
        // 表单验证错误
        return
      }
      console.error('保存个人信息失败:', error)
      message.error(error?.msg || t('09d751d2'))
    } finally {
      setLoading(false)
    }
  }


  const handleChange = async(e: any) => {
    const file = e?.target?.files?.[0];
    if (!file) return;
    const f = new FormData();
    f.append('file', file);
    const res = await apiFileUpload(f);
    if (res.code === 0) {
      setImageUrl(res.data);
    } else {
      message.error(res.msg || t('27604e7c'));
    }
  };

  return (
    <div className='w-8xl mx-auto px-10 leading-[1.5]'>
      <div className='py-10'>
        <LangText lngKey='9cd7aa87' className='text-[30px] font-bold '>{t('9cd7aa87')}</LangText>
      </div>
      <div>
        <div className=''>
          <div className='flex flex-col'>
            <LangText lngKey='3af221ad' className='text-[28px] font-bold '>{t('3af221ad')}</LangText>
            <LangText lngKey='377953dd' className='text-[16px] text-[#666666] mt-2'>{t('377953dd')}</LangText>
          </div>
          <div className='bg-white rounded-[20px] px-8 py-6 mt-6'>
            <div className='flex justify-between items-center pb-6 mb-6 border-b border-[#D9D9D9]'>
              <div className='h-[74px] w-[74px] rounded-full relative'>
                {imageUrl ? (
                  <img draggable={false} src={imageUrl} alt="avatar" style={{ width: '100%' }} />
                ) : (
                  <img src={preFixImgUrl(userStore.user?.headimgurl ?? '585a3f702bf0be02a45f07f520f474b3.png')} className='h-[74px] w-[74px] rounded-full' />
                )}
                {isEdit && <input type='file' className='absolute inset-0 opacity-0 cursor-pointer' accept='image/*' onChange={handleChange} />}
              </div>
              {
                isEdit ? <div className='flex gap-6 text-[20px]'>
                  <LangText lngKey='3a2308ec' className='text-[#666666] cursor-pointer' onClick={handleEdit}>{t('3a2308ec')}</LangText>
                  <LangText
                    lngKey={loading ? '3771e3dc' : '5aeff2f2'}
                    className={`text-[#5a52ff] cursor-pointer ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                    onClick={loading ? undefined : handleSave}
                  >
                    {loading ? t('3771e3dc') : t('5aeff2f2')}
                  </LangText>
                </div> : <LangText lngKey='e077be56' className='text-[20px] font-bold text-[#5a52ff] cursor-pointer' onClick={handleEdit}>{t('e077be56')}</LangText>
              }
            </div>
            <Form
              disabled={!isEdit}
              layout='vertical'
              form={form}
              initialValues={{
                nickname: userStore.user?.nickname,
                email: userStore.user?.email,
                mobile: userStore.user?.mobile,
              }}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name='nickname' label={t('8fbc9b65')} rules={[{ required: false, message: t('17403783') }]}>
                    <Input placeholder={t('61f1b008')} className='h-[44px]' />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name='email'
                    label={t('0684da87')}
                    rules={[
                      { required: false },
                      { type: 'email', message: t('aba0aa71') }
                    ]}
                  >
                    <Input disabled={!isEdit || userStore.user?.account === userStore.user?.email} placeholder={t('5e21b2f8')} className='h-[44px]' />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name='mobile'
                    label={t('88939319')}
                    rules={[
                      { required: false },
                      { pattern: /^1\d{10}$/, message: t('08eacc5f') }
                    ]}
                  >
                    <Input disabled={!isEdit || userStore.user?.account === userStore.user?.mobile} placeholder={t('39dfe809')} className='h-[44px]' />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
          <div className='flex flex-col mt-10'>
            <LangText lngKey='477e6001' className='text-[28px] font-bold '>{t('477e6001')}</LangText>
            <LangText lngKey='cb564a70' className='text-[16px] text-[#666666] mt-2'>{t('cb564a70')}</LangText>
          </div>
          <div className='bg-white rounded-[20px] px-8 py-6 mt-6'>
            <div className='flex justify-between items-center'>
              <div className='flex items-center'>
                <img src={preFixImgUrl('448436e198fff5eaf9a9cd876a38fe65.png')} className='mr-3 w-12 h-12' />
                <div className='flex flex-col'>
                  <LangText lngKey='827868b2' className='text-[20px]'>{t('827868b2')}</LangText>
                  <LangText lngKey='50735985' className='text-[16px] text-[#666666] mt-1'>{t('50735985')}: {(() => {
                    const account = userStore.user?.account ?? '';
                    // 手机号判断: 仅数字且长度为11，且以1开头
                    if (/^1\d{10}$/.test(account)) {
                      // 隐藏中间4位
                      return account.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
                    }
                    // 邮箱判断: 包含@且长度大于3
                    if (/^[^@]{3,}@/.test(account)) {
                      const [name, domain] = account.split('@');
                      return `${name.slice(0, 3)}****@${domain}`;
                    }
                    // 默认展示原值
                    return account;
                  })()}
                  </LangText>
                </div>
              </div>
              <div className='border border-[#D9D9D9] rounded-[24px] cursor-pointer leading-[44px] px-7' onClick={() => setIsEditPassword(true)}>
                <LangText lngKey='e694b7b8' className='text-[18px] text-[#666666]'>{t('e694b7b8')}</LangText>
              </div>
              <Modal maskClosable open={isEditPassword} onCancel={() => setIsEditPassword(false)} destroyOnHidden footer={null} closable={false}>
                <EditPasswordForm onClose={() => setIsEditPassword(false)} />
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default Profile